import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Button } from "@cleartrip/bento/lib";
import Sandbox from '@components/Sandbox';
import Playground from '@components/Playground';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "button"
    }}>{`Button`}</h1>
    <p>{`Buttons are used to make common actions visible`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Text>
    import {'{ Button }'} from '@cleartrip/bento'
  </Sandbox.Text>
    </Sandbox>
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <Playground __position={1} __code={''} __scope={{
      props,
      DefaultLayout,
      Button,
      Sandbox,
      Playground,
      DefaultLayout,
      _frontmatter
    }} code="<Button>Hello</Button>" scope={{
      Button
    }} mdxType="Playground" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      